// Base URL for ball fitting service
export const BALL_FITTING_BASE_URL = 'https://ballfitting.com/my-fitting/your-profile';

// Ball fitting parameter specifications
export const BALL_FITTING_SPECS = {
	Drivers: {
		ballSpeed: { min: 80, max: 200, roundTo: 1 }, // whole numbers
		launchAngle: { min: 6, max: 18, roundTo: 0.5 }, // multiples of 0.5
		spinRate: { min: 1400, max: 3800, roundTo: 50 } // multiples of 50
	},
	Irons: {
		ballSpeed: { min: 60, max: 150, roundTo: 1 }, // whole numbers
		launchAngle: { min: 10, max: 25, roundTo: 0.5 }, // multiples of 0.5
		spinRate: { min: 4000, max: 8500, roundTo: 50 } // multiples of 50
	},
	Hybrid: {
		ballSpeed: { min: 70, max: 180, roundTo: 1 }, // whole numbers
		launchAngle: { min: 8, max: 22, roundTo: 0.5 }, // multiples of 0.5
		spinRate: { min: 2500, max: 5500, roundTo: 50 } // multiples of 50
	},
	Wood: {
		ballSpeed: { min: 75, max: 190, roundTo: 1 }, // whole numbers
		launchAngle: { min: 7, max: 20, roundTo: 0.5 }, // multiples of 0.5
		spinRate: { min: 2000, max: 4500, roundTo: 50 } // multiples of 50
	},
	Wedge: {
		ballSpeed: { min: 50, max: 130, roundTo: 1 }, // whole numbers
		launchAngle: { min: 12, max: 30, roundTo: 0.5 }, // multiples of 0.5
		spinRate: { min: 5000, max: 10000, roundTo: 50 } // multiples of 50
	}
};

// Helper function to round a value to the nearest multiple
export const roundToNearest = (value, multiple) => {
	return Math.round(value / multiple) * multiple;
};

// Helper function to clamp and round a value according to specifications
export const applySpec = (value, spec) => {
	const clampedValue = Math.max(spec.min, Math.min(spec.max, value));
	return roundToNearest(clampedValue, spec.roundTo);
};

// Club type constants
export const CLUB_TYPES = {
	DRIVERS: 'Drivers',
	IRONS: 'Irons',
	HYBRID: 'Hybrid',
	WOOD: 'Wood',
	WEDGE: 'Wedge'
};

// URL parameter names for different club types
export const URL_PARAMS = {
	DRIVER: {
		ballSpeed: 'driverBallSpeed',
		launch: 'driverLaunch',
		spin: 'driverSpin'
	},
	IRON: {
		ballSpeed: 'ironBallSpeed',
		launch: 'ironLaunch',
		spin: 'ironSpin'
	},
	HYBRID: {
		ballSpeed: 'hybridBallSpeed',
		launch: 'hybridLaunch',
		spin: 'hybridSpin'
	},
	WOOD: {
		ballSpeed: 'woodBallSpeed',
		launch: 'woodLaunch',
		spin: 'woodSpin'
	},
	WEDGE: {
		ballSpeed: 'wedgeBallSpeed',
		launch: 'wedgeLaunch',
		spin: 'wedgeSpin'
	}
};

// Formulas to estimate club values from each other
export const CLUB_CONVERSION_FORMULAS = {
	// Convert driver values to iron values (6i = iron, Dr = driver)
	driverToIron: {
		ballSpeed: (drBallSpeed) => 2 + 0.78 * drBallSpeed,
		launchAngle: (drLaunchAngle) => 7 + 0.6 * drLaunchAngle,
		spinRate: (drSpinRate) => 2200 + 1.1 * drSpinRate
	},
	// Convert iron values to driver values
	ironToDriver: {
		ballSpeed: (ironBallSpeed) => 10 + 1.17 * ironBallSpeed,
		launchAngle: (ironLaunchAngle) => 5 + 0.5 * ironLaunchAngle,
		spinRate: (ironSpinRate) => 800 + 0.36 * ironSpinRate
	}
};

export const mockBallData = [
	{
		id: 1,
		manufacturer: "Bridgestone",
		year: 2020,
		available: 1,
		shown: 0,
		salesforceSku: "19867",
		name: "Bridgestone 2020 Tour B RX White Golf Balls - DOWX6D",
		code: "DOWX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 2,
		manufacturer: "Bridgestone",
		year: 2020,
		available: 1,
		shown: 0,
		salesforceSku: "19869",
		name: "Bridgestone 2020 Tour B RXS White Golf Balls - COWX6D",
		code: "COWX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 3,
		manufacturer: "Bridgestone",
		year: 2020,
		available: 1,
		shown: 0,
		salesforceSku: "19864",
		name: "Bridgestone 2020 Tour B X White Golf Balls - BOWX6D",
		code: "BOWX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 4,
		manufacturer: "Bridgestone",
		year: 2020,
		available: 1,
		shown: 0,
		salesforceSku: "19865",
		name: "Bridgestone 2020 Tour B XS White Golf Balls - SOWX6D",
		code: "SOWX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 5,
		manufacturer: "Bridgestone",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "23439",
		name: "Bridgestone 2022 Tour B X White Golf Balls - B2WX6D",
		code: "B2WX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 6,
		manufacturer: "Bridgestone",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "23440",
		name: "Bridgestone 2022 Tour B XS White Golf Balls - S2WX6D",
		code: "S2WX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 7,
		manufacturer: "Bridgestone",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "23444",
		name: "Bridgestone 2022 Tour B RX White Golf Balls - D2WX6D",
		code: "D2WX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 8,
		manufacturer: "Bridgestone",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "23446",
		name: "Bridgestone 2022 Tour B RXS White Golf Balls",
		code: "C2WX6D",
		price: 49.99,
		back_order: false
	},
	{
		id: 9,
		manufacturer: "Bridgestone",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "34392",
		name: "Bridgestone 2024 Tour B RX White Golf Balls",
		code: "BRX24",
		price: 54.99,
		back_order: false
	},
	{
		id: 10,
		manufacturer: "Bridgestone",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "34395",
		name: "Bridgestone 2024 Tour B RXS White Golf Balls",
		code: "BRXS24",
		price: 54.99,
		back_order: false
	},
	{
		id: 11,
		manufacturer: "Bridgestone",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "34390",
		name: "Bridgestone 2024 Tour B XS White Golf Balls",
		code: "BXS24",
		price: 54.99,
		back_order: false
	},
	{
		id: 12,
		manufacturer: "Bridgestone",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "34388",
		name: "Bridgestone 2024 Tour B X White Golf Balls",
		code: "BX24",
		price: 54.99,
		back_order: false
	},
	{
		id: 13,
		manufacturer: "Callaway",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "22965",
		name: "Callaway 2022 Chrome Soft X LS Golf Balls",
		code: "CSXLS22",
		price: 49.99,
		back_order: false
	},
	{
		id: 14,
		manufacturer: "Callaway",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "22957",
		name: "Callaway 2022 Chrome Soft Golf Balls",
		code: "CS22",
		price: 49.99,
		back_order: false
	},
	{
		id: 15,
		manufacturer: "Callaway",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "22962",
		name: "Callaway 2022 Chrome Soft X Golf Balls",
		code: "CSX22",
		price: 49.99,
		back_order: false
	},
	{
		id: 16,
		manufacturer: "Callaway",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "33502",
		name: "Callaway 2024 Chrome Soft Golf Balls",
		code: "CS24",
		price: 54.99,
		back_order: false
	},
	{
		id: 17,
		manufacturer: "Callaway",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "33508",
		name: "Callaway 2024 Chrome Tour Golf Balls",
		code: "CT24",
		price: 54.99,
		back_order: false
	},
	{
		id: 18,
		manufacturer: "Callaway",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "33514",
		name: "Callaway 2024 Chrome Tour X Golf Balls",
		code: "CTX24",
		price: 54.99,
		back_order: false
	},
	{
		id: 19,
		manufacturer: "Callaway",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "37615",
		name: "Callaway 2025 Chrome Tour Triple Diamond Golf Balls",
		code: "CTTD25",
		price: 59.99,
		back_order: false
	},
	{
		id: 20,
		manufacturer: "LA Golf",
		year: 2023,
		available: 1,
		shown: 1,
		salesforceSku: "32207",
		name: "LA Golf Balls",
		code: "LAG23",
		price: 39.99,
		back_order: false
	},
	{
		id: 21,
		manufacturer: "Srixon",
		year: 2022,
		available: 1,
		shown: 1,
		salesforceSku: "34843",
		name: "Srixon Q-Star Tour 5 Golf Balls - White",
		code: "QST22",
		price: 34.99,
		back_order: false
	},
	{
		id: 22,
		manufacturer: "Srixon",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "35959",
		name: "Srixon Z-Star 9 Golf Balls - White",
		code: "ZS925",
		price: 49.99,
		back_order: false
	},
	{
		id: 23,
		manufacturer: "Srixon",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "35962",
		name: "Srixon Z-Star XV 9 Golf Balls - White",
		code: "ZSXV25",
		price: 49.99,
		back_order: false
	},
	{
		id: 24,
		manufacturer: "Srixon",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "35965",
		name: "Srixon Z-Star Diamond 3 Golf Balls - White",
		code: "ZSD25",
		price: 54.99,
		back_order: false
	},
	{
		id: 25,
		manufacturer: "TaylorMade",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "33912",
		name: "Taylor Made 2024 TP5 Golf Balls - White",
		code: "TP524",
		price: 54.99,
		back_order: false
	},
	{
		id: 26,
		manufacturer: "TaylorMade",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "33914",
		name: "Taylor Made 2024 TP5x Golf Balls - White",
		code: "TP5X24",
		price: 54.99,
		back_order: false
	},
	{
		id: 27,
		manufacturer: "Titleist",
		year: 2020,
		available: 1,
		shown: 1,
		salesforceSku: "20844",
		name: "Titleist Tour Speed Golf Balls",
		code: "TS20",
		price: 39.99,
		back_order: false
	},
	{
		id: 28,
		manufacturer: "Titleist",
		year: 2019,
		available: 1,
		shown: 1,
		salesforceSku: "22816",
		name: "Titleist 2021 Pro V1x LEFT DASH Golf Ball",
		code: "PV1XLD19",
		price: 54.99,
		back_order: false
	},
	{
		id: 29,
		manufacturer: "Titleist",
		year: 2022,
		available: 1,
		shown: 0,
		salesforceSku: "23669",
		name: "Titleist 2022 AVX Golf Ball",
		code: "AVX22",
		price: 54.99,
		back_order: false
	},
	{
		id: 30,
		manufacturer: "Titleist",
		year: 2023,
		available: 1,
		shown: 0,
		salesforceSku: "30254",
		name: "Titleist 2023 Pro V1 Golf Ball",
		code: "PV123",
		price: 54.99,
		back_order: false
	},
	{
		id: 31,
		manufacturer: "Titleist",
		year: 2023,
		available: 1,
		shown: 0,
		salesforceSku: "30255",
		name: "Titleist 2023 Pro V1x Golf Ball",
		code: "PV1X23",
		price: 54.99,
		back_order: false
	},
	{
		id: 32,
		manufacturer: "Titleist",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "33844",
		name: "Titleist 2024 AVX Golf Ball",
		code: "AVX24",
		price: 54.99,
		back_order: false
	},
	{
		id: 33,
		manufacturer: "Titleist",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "36924",
		name: "Titleist 2025 Pro V1x Golf Ball - White",
		code: "PV1X25",
		price: 59.99,
		back_order: false
	},
	{
		id: 34,
		manufacturer: "Titleist",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "36923",
		name: "Titleist 2025 Pro V1 Golf Ball - White",
		code: "PV125",
		price: 59.99,
		back_order: false
	},
	{
		id: 35,
		manufacturer: "Wilson",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "36044",
		name: "Wilson Staff Model Golf Ball - White",
		code: "WSM24",
		price: 49.99,
		back_order: false
	},
	{
		id: 36,
		manufacturer: "Wilson",
		year: 2024,
		available: 1,
		shown: 1,
		salesforceSku: "36046",
		name: "Wilson Staff Model X Golf Ball - White",
		code: "WSMX24",
		price: 49.99,
		back_order: false
	},
	{
		id: 37,
		manufacturer: "Wilson",
		year: 2025,
		available: 1,
		shown: 1,
		salesforceSku: "37604",
		name: "Wilson Triad Golf Balls - White",
		code: "WT25",
		price: 44.99,
		back_order: false
	},
	{
		id: 38,
		manufacturer: "XXIO",
		year: 2020,
		available: 1,
		shown: 1,
		salesforceSku: "22326",
		name: "XXIO X White Golf Balls - No Replenishment",
		code: "XXIOX20",
		price: 59.99,
		back_order: false
	}
];
